import _ from "lodash";
import { EntityDescriptor, EntityTablePage, EntityTablePageProps, EntityTablePageReducers, EntityTablePageState } from "@crispico/foundation-react";
import { ReduxReusableComponents } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import { GanttAssignmentParams_ConfigEntityRequirementsJsonFieldDescriptor } from "./GanttAssignmentParamsFieldsDescriptor";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";

const GANTT_ASSIGNMENT_PARAMS_TABLE_ROW_HEIGHT = 100;

export class GanttAssignmentParamsEntityDescriptor extends EntityDescriptor {
    constructor() {
        super({
            name: "GanttAssignmentParams"
        });
    }

    protected customize() {
        this.addFieldDescriptor({ name: "name", type: FieldType.string })
            .addFieldDescriptor({ name: "flightAndObjectActionFilter", type: FieldType.filter, entityName: "FlightAndObjectAction", filterable: false, sortable: false })
            .addFieldDescriptor(new GanttAssignmentParams_ConfigEntityRequirementsJsonFieldDescriptor());
    }

    renderTable() {
        return <GanttAssignmentParamsTablePageRRC {...super.renderTable().props} ref={this.entityTablePage} />;
    }
}

class GanttAssignmentParamsTablePage extends EntityTablePage<EntityTablePageProps> {

    protected getTableProps() {
        return { rowHeight: GANTT_ASSIGNMENT_PARAMS_TABLE_ROW_HEIGHT };
    }
}

const GanttAssignmentParamsTablePageRRC = ReduxReusableComponents.connectRRC(EntityTablePageState, EntityTablePageReducers, GanttAssignmentParamsTablePage);
